import { WarningOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React from "react";
import { Alert } from "../api/models";
import { BeaconActiveErrorsTooltip } from "./BeaconActiveErrorsTooltip";

interface BeaconErrorStatusProps {
  errors: Alert[] | undefined;
  style?: React.CSSProperties;
  showTooltip?: boolean;
}

export function BeaconErrorStatus({
  errors,
  style,
  showTooltip,
}: BeaconErrorStatusProps) {
  return showTooltip ? (
    <Tooltip
      style={{ width: "auto" }}
      title={<BeaconActiveErrorsTooltip errors={errors!} />}
      overlayStyle={{ width: "auto", maxWidth: 800 }}
    >
      <WarningOutlined style={{ ...style, color: "orange" }} />
    </Tooltip>
  ) : (
    <WarningOutlined style={{ ...style, color: "orange" }} />
  );
}
